// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-field__label[data-v-6e27454b]{overflow:hidden;text-overflow:ellipsis}.dropdown-field__list-item[data-v-6e27454b]{overflow:hidden}.dropdown-field__dropdown-attached[data-v-6e27454b]{contain:none;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
